import LoadingBtn from '../loadingBtn/view';
import { useEffect, useState } from 'react';
import { listener } from '../../../utils/dispatch';
import { lang } from '../../../utils/langs';
import { BsTrash } from 'react-icons/bs';
import { Plus } from 'lucide-react';
import Tooltip from '@mui/material/Tooltip';
import "./style.css"

function ButtonAction({
    id,
    btnKey,
    onClick = undefined,
    enableLoadingAnimation = false,
    title,
    data,
    children,
    hidden = false,
    disabled = false,
    style = {},
    className = "",
    variant = "primary",
    tooltip = undefined,
}) {

    const [loading, setLoading] = useState(false)

    const isDanger = variant === 'danger' || variant === 'delete';
    const isAdd = variant === 'add' || variant === 'plus';
    const variantClass = isDanger ? 'btn-action-danger' : '';

    // Determinamos el ícono por defecto según la variante
    let defaultTitle = null;
    if (isDanger) defaultTitle = <BsTrash />;
    if (isAdd) defaultTitle = <Plus size={20} strokeWidth={2.5} />;

    // Si el padre envía una prop 'title' (incluso si fuera un string o nodo JSX), esta tiene prioridad sobre el defaultTitle
    const content = (title !== undefined && title !== null) ? title : defaultTitle;

    useEffect(() => {
        listener(btnKey ? `loading-btn-${btnKey}` : 'loading-btn', () => { setLoading(false) })
        listener('loading-btn', () => { setLoading(false) })
    }, [btnKey]);

    function eventCustom(e) {
        e.preventDefault();
        e.stopPropagation();
        if (enableLoadingAnimation) setLoading(true)
        if (onClick) { onClick(data) }
    }

    // 👇 Evaluamos si hidden/disabled son funciones o booleanos
    const isHidden = typeof hidden === 'function' ? hidden(data) : hidden;
    const isDisabled = typeof disabled === 'function' ? disabled(data) : disabled;

    if (isHidden) {
        return null;
    }

    const buttonElement = (
        <button
            id={id || (btnKey ? btnKey : "btn-action")}
            aria-disabled={loading ? "true" : "false"}
            className={`btn-action ${variantClass} ${className}`.trim()}
            onClick={eventCustom}
            disabled={loading || isDisabled}
            type='button'
            style={style}
        >
            <LoadingBtn loading={loading}>
                {children}
                {typeof content === 'string' ? lang('es', content) : content}
            </LoadingBtn>
        </button>
    );

    const resolvedTooltip = typeof tooltip === 'function' ? tooltip(data) : tooltip;

    if (resolvedTooltip) {
        return (
            <Tooltip title={resolvedTooltip} arrow enterDelay={200} leaveDelay={100}>
                <span style={{ display: 'inline-flex' }}>{buttonElement}</span>
            </Tooltip>
        );
    }

    return buttonElement;

}

export default ButtonAction

